<cb-dialog
    class="pdf-viewer-dialog"
    [dialogHeading]="getItemTitle(selectedItem)"
    [showActions]="false"
    [fullscreen]="true"
>
    <div class="pdf-viewer-dialog__body">
        <div class="pdf-viewer-dialog__sidebar" [class.pdf-viewer-dialog__sidebar--collapsed]="sidebarCollapsed">
            <div class="pdf-viewer-dialog__sidebar-header">
                @if (!sidebarCollapsed) {
                    <span class="pdf-viewer-dialog__sidebar-title">{{ listTitle }} ({{ data.items.length }})</span>
                }
                <button
                    mat-icon-button
                    [matTooltip]="(sidebarCollapsed ? 'Show ' : 'Hide ') + (listTitle | lowercase)"
                    matTooltipPosition="right"
                    (click)="toggleSidebar()"
                >
                    <mat-icon>{{ sidebarCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
                </button>
            </div>
            @if (!sidebarCollapsed) {
                <mat-nav-list #documentList class="pdf-viewer-dialog__list">
                    @for (group of groups; track group.key) {
                        @if (showGroupHeaders) {
                            <mat-list-item
                                class="pdf-viewer-dialog__group"
                                [disableRipple]="true"
                                (click)="toggleGroup(group)"
                            >
                                <mat-icon matListItemIcon>{{ isGroupExpanded(group) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                                <span matListItemTitle class="pdf-viewer-dialog__group-title">
                                    {{ group.name | uppercase }} ({{ group.items.length }})
                                </span>
                            </mat-list-item>
                        }
                        @if (isGroupExpanded(group)) {
                            @for (item of group.items; track item.id) {
                                <mat-list-item
                                    class="pdf-viewer-dialog__item"
                                    [class.pdf-viewer-dialog__item--nested]="showGroupHeaders"
                                    [class.pdf-viewer-dialog__item--selected]="item.id === selectedItem?.id"
                                    [activated]="item.id === selectedItem?.id"
                                    [matTooltip]="getItemTitle(item)"
                                    matTooltipPosition="right"
                                    [matTooltipShowDelay]="500"
                                    (click)="select(item)"
                                >
                                    <mat-icon matListItemIcon>picture_as_pdf</mat-icon>
                                    <span matListItemTitle>{{ item.name }}</span>
                                </mat-list-item>
                            }
                        }
                    }
                </mat-nav-list>
            }
        </div>
        <cb-pdf-viewer
            class="pdf-viewer-dialog__viewer"
            [src]="pdfBlob"
            [documentName]="downloadFilename"
            [loading]="loading"
            [loadingKey]="loadCount"
            [emptyMessage]="loadError ? 'Unable to load the document' : 'No document selected'"
            [emptyDescription]="loadError ? loadErrorDescription : 'Select a document from the list to preview it here.'"
            [showRetry]="loadError && canRetryLoad"
            (retry)="retry()"
            (loadingFailed)="onViewerLoadingFailed()"
        >
        </cb-pdf-viewer>
    </div>
</cb-dialog>
